import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { getPrimaryLanguage } from "@krea/customer-features/utils";
import { bankIDTranslations } from "@krea/shared/features/bankID";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        partnerWeb: require("./translations/partner/en.json"),
        common: require("@krea/customer-features/translations/common/en.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/en.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.en,
      },
      sv: {
        partnerWeb: require("./translations/partner/sv.json"),
        common: require("@krea/customer-features/translations/common/sv.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/sv.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.sv,
      },
      fi: {
        partnerWeb: require("./translations/partner/fi.json"),
        common: require("@krea/customer-features/translations/common/fi.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/fi.json"),
        [bankIDTranslations.namespace]: bankIDTranslations.fi,
      },
    },
    lng: getPrimaryLanguage(),
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "fi"],
    ns: [
      "partnerWeb",
      "partnerApplication",
      "common",
      bankIDTranslations.namespace,
    ],
    defaultNS: [
      "partnerWeb",
      "partnerApplication",
      bankIDTranslations.namespace,
      "common",
    ],
    fallbackNS: ["partnerApplication", bankIDTranslations.namespace, "common"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li"],
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
